<div class="container">
  <mat-icon>search</mat-icon>
  <input class="search-input" type="text"
    [placeholder]="placeholder"
    (keyup)="debounce.next($any($event).target.value)">
</div>
